import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _isUndefined from "lodash/isUndefined";
import _omitBy from "lodash/omitBy";
import _isNumber from "lodash/isNumber";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { getLearnMoreLink, getProductType, getStarRating } from '@nerdwallet/marketplace/selectors/common';
import BaseMarketplaceStarRating from './base-marketplace-star-rating'; // export for testing

export var getMappedProps = function getMappedProps(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity,
      ratingTextHref = _ref.ratingTextHref,
      starRating = _ref.starRating,
      props = _objectWithoutProperties(_ref, ["marketplaceEntity", "ratingTextHref", "starRating"]);

  return _objectSpread({
    marketplaceEntity: marketplaceEntity,
    productType: getProductType(marketplaceEntity),
    ratingTextHref: ratingTextHref || getLearnMoreLink(marketplaceEntity),
    // Check isNumber to bypass 0 evaluating as falsy
    starRating: _isNumber(starRating) ? starRating : getStarRating(marketplaceEntity)
  }, _omitBy(props, function (val) {
    return _isUndefined(val);
  }));
};

var MarketplaceStarRating = function MarketplaceStarRating(props) {
  useDeprecatedPropsWarning({
    component: 'MarketplaceStarRating',
    deprecatedProps: [{
      version: '2.11.0',
      deprecated: 'enableAnalytics',
      migration: 'use analytics instead'
    }],
    props: props
  });
  return /*#__PURE__*/React.createElement(BaseMarketplaceStarRating, getMappedProps(props));
};

MarketplaceStarRating.propTypes = _objectSpread(_objectSpread({}, BaseMarketplaceStarRating.propTypes), {}, {
  /** Marketplace entity to render. */
  marketplaceEntity: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types

});
export default MarketplaceStarRating;